import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSidebarIconSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32.002}
    height={18.001}
    data-name="Group 52"
    {...props}
  >
    <g data-name="White Box">
      <path fill="#fff" d="M31.502 17.501h-31v-17h31Z" data-name="Path 1" />
      <path fill="#024" d="M1 1v16h30V1zM0 0h32v18H0Z" data-name="Path 2" />
    </g>
    <path fill="#024" d="M2 1.999h21.092v14H2Z" data-name="Grey Box" />
    <g fill="#024" data-name="Group 153">
      <path d="M24 2h6v4h-6Z" data-name="Grey Box-2" />
      <path d="M24 6.999h6v4h-6Z" data-name="Grey Box-3" />
      <path d="M24 12h6v4h-6Z" data-name="Grey Box-4" />
    </g>
  </svg>
);
export default SvgSidebarIconSmall;
